<template>
    <div class="title-block">
        <div class="title-block__left">
            <div class="title-block__title">Бренды</div>
            <a class="title-block__btn btn-add btn-primary btn" :href="route_create_page">Добавить бренд</a>
        </div>
    </div>

    <table-element :actions="actions" :thead="thead" :tbody="tbody" @deleteItem="deleteBrand" @editItem="updateBrand"></table-element>
    <pagination-element :count="count" :current_page="page" @pageChange="pageChange"></pagination-element>
</template>

<script>
import Brand from "../../../models/Brand";
import ListView from "../../../elements/ListView";
import ChangePage from "../../../helpers/ChangePage";
import TableElement from "../../../elements/TableElement";
import PaginationElement from "../../../elements/PaginationElement";

export default {
    name: "BrandComponent",
    components: {
        TableElement,
        PaginationElement,
        ListView
    },
    props: {
        route_create_page: String,
        route_edit_page: String,
        route_list: String,
        route_delete: String,
        route_get: String,
        route_update: String,
        current_page: {
            type: Number,
            default: 1
        }
    },
    data: function () {
        return {
            brand: new Brand({
                route_list: this.route_list,
                route_delete: this.route_delete
            }),
            search: '',
            actions: [
                {
                    text: 'Изменить',
                    emit: 'editItem',
                    svg: `<button class="table-action table-action_edit m-auto align-middle" title="Редактировать"></button>`
                },
                {
                    text: 'Удалить',
                    emit: 'deleteItem',
                    svg: `<button class="table-action table-action_delete m-auto align-middle" title="Удалить"></button>`
                },
            ],
            thead: [
                'Название'
            ],
            tbody: [],
            count: 1,
            limit: 30,
            page: 1,
        }
    },
    methods: {
        deleteBrand: function (params) {
            if(params.hasOwnProperty('id'))
            {
                let id = params.id;
                this.brand.delete(id).then(this.loadTable);
            }
            else
            {
                console.log('Error: delete_item_undefined');
            }
        },
        loadTable: async function () {
            let response = await this.brand.loadTable(this.page, this.limit, this.search);
            this.tbody = response.tbody;
            this.count = response.pages;
            if(this.page > 1 && this.tbody.length === 0)
            {
                this.page = 1;
                ChangePage(this.page, false);
                await this.loadTable();
            }
        },
        pageChange: function (newPage) {
            this.page = newPage;
            this.loadTable();
        },
        updateBrand: function (params) {
            window.location.href = this.route_edit_page+params.id;
        }
    },
    mounted() {
        this.loadTable();
    }
}
</script>

<style scoped>

</style>
